let current_blank_id = 0

export function getBlandID(){
    return --current_blank_id
}

export function getCSRFToken(){
    return document.querySelector('[name="csrfmiddlewaretoken"]').value
}